import { render } from "./DeleteUser.vue?vue&type=template&id=c59efa6a&scoped=true"
import script from "./DeleteUser.vue?vue&type=script&lang=js"
export * from "./DeleteUser.vue?vue&type=script&lang=js"

import "./DeleteUser.vue?vue&type=style&index=0&id=c59efa6a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c59efa6a"]])

export default __exports__